import { render, staticRenderFns } from "./CockpitDetailDialog.vue?vue&type=template&id=4de32f3a&scoped=true&lang=pug&"
import script from "./CockpitDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./CockpitDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CockpitDetailDialog.vue?vue&type=style&index=0&id=4de32f3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de32f3a",
  null
  
)

export default component.exports